import React from "react";
import {url} from "../utils/UrlsUtil";
import "../../style/common/footer/_footer.scss";

interface FooterProps {

}

const Footer:React.FC<FooterProps> = ({}) => {
  return (
      <div id="pageFooter" className="row">
          <div className="col-12">
              <div className="footer-contents">
                  <img src={url("/images/logo/geeva_logo_color.png")}/>
                  <p>
                      ■このフォームに入力された情報は、楽天グループ株式会社ではなく、当店が管理しています。<br/>
                      ■このフォームに入力された情報に関するお問い合わせは<br/>
                      直接当店にお願いいたします。楽天グループ株式会社では対応できません。<br/>
                      ■このフォームで入力された情報につきましては、当店は、<br/>
                      ギフトアレンジの目的でのみ利用します。<br/>
                  </p>
              </div>
          </div>
      </div>
  );
};
export default Footer;